<div class="space-y-3">
  @if (summary(); as summary) {
    <p
      class="rounded-md bg-primary-50 px-3 py-2 text-paragraph-s-reg text-primary-900"
      aria-live="polite"
    >
      {{ summary }}
    </p>
  }

  <section
    class="space-y-1 rounded-lg border border-greyscale-200 bg-white p-3"
  >
    <h5 class="text-paragraph-xs-semi text-primary-900">
      {{ "objectives.transportAlternativeOptions.flightsTitle" | transloco }}
    </h5>
    <div
      class="flex flex-wrap items-center gap-2 text-paragraph-s-reg text-greyscale-800"
    >
      <label for="alt-max-flight-distance">
        {{
          "objectives.transportAlternativeOptions.maxFlightDistanceKm"
            | transloco
        }}
      </label>
      <p-inputNumber
        inputId="alt-max-flight-distance"
        [ngModel]="maxFlightDistanceKm()"
        (ngModelChange)="maxFlightDistanceKm.set($event)"
        [min]="bounds.maxFlightDistanceKm.min"
        [max]="bounds.maxFlightDistanceKm.max"
        [step]="100"
        suffix=" km"
        [placeholder]="
          'objectives.transportAlternativeOptions.noLimit' | transloco
        "
        size="small"
        styleClass="w-32"
      />
    </div>
    <p class="text-paragraph-xs-reg text-greyscale-600">
      {{
        "objectives.transportAlternativeOptions.maxFlightDistanceHint"
          | transloco
      }}
    </p>
  </section>

  <section
    class="space-y-3 rounded-lg border border-greyscale-200 bg-white p-3"
  >
    <h5 class="text-paragraph-xs-semi text-primary-900">
      {{
        "objectives.transportAlternativeOptions.alternativesTitle" | transloco
      }}
    </h5>

    <div>
      <span class="text-paragraph-xs-semi text-greyscale-800">
        {{ "objectives.transportAlternativeOptions.allowedModes" | transloco }}
      </span>
      <div class="mt-1 flex flex-wrap gap-x-4 gap-y-2">
        @for (mode of modes; track mode) {
          <div class="flex items-center gap-2">
            <p-checkbox
              [binary]="true"
              [ngModel]="isAllowed(mode)"
              (onChange)="toggleMode(mode)"
              [inputId]="'alt-mode-' + mode"
            />
            <label
              [for]="'alt-mode-' + mode"
              class="cursor-pointer text-paragraph-s-reg text-greyscale-800"
            >
              {{ "reductionTips.transportAlternative." + mode | transloco }}
            </label>
          </div>
        }
      </div>
      @if (allowedModes().length === 0) {
        <p class="mt-1 text-paragraph-xs-reg text-red-600">
          {{ "objectives.transportAlternativeOptions.noModeError" | transloco }}
        </p>
      }
    </div>

    <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <div class="flex flex-col gap-1">
        <label
          for="alt-max-duration"
          class="text-paragraph-xs-semi text-greyscale-800"
        >
          {{
            "objectives.transportAlternativeOptions.maxDurationHours"
              | transloco
          }}
        </label>
        <p-inputNumber
          inputId="alt-max-duration"
          [ngModel]="maxDurationHours()"
          (ngModelChange)="maxDurationHours.set($event)"
          [min]="bounds.maxDurationHours.min"
          [max]="bounds.maxDurationHours.max"
          suffix=" h"
          [placeholder]="
            'objectives.transportAlternativeOptions.noLimit' | transloco
          "
          [fluid]="true"
          size="small"
        />
      </div>

      <div class="flex flex-col gap-1">
        <label
          for="alt-max-changes"
          class="text-paragraph-xs-semi text-greyscale-800"
        >
          {{ "objectives.transportAlternativeOptions.maxChanges" | transloco }}
        </label>
        <p-inputNumber
          inputId="alt-max-changes"
          [ngModel]="maxChanges()"
          (ngModelChange)="maxChanges.set($event)"
          [min]="bounds.maxChanges.min"
          [max]="bounds.maxChanges.max"
          [placeholder]="
            'objectives.transportAlternativeOptions.noLimit' | transloco
          "
          [fluid]="true"
          size="small"
        />
      </div>
    </div>
  </section>

  <div class="flex justify-end">
    <p-button
      [label]="'objectives.transportAlternativeOptions.save' | transloco"
      size="small"
      [disabled]="!canSave()"
      [loading]="isSaving()"
      (onClick)="save()"
    />
  </div>
</div>
